import { getWarrantyUrl } from '@catalogo/core-helpers/url';
import { MODAL_WARRANTY_URL_REF } from '@catalogo/service-americanas-cart/src/helpers/add-to-cart-pdp';

export const getUrl = (
  productId,
  currentSku,
  sellerStoreId,
  buyTogether,
  productQty = 1,
  servicePDPinfoForWarranty
) => {
  const isBuyTogetherSelected = buyTogether?.buyTogetherVIP?.active ?? false;
  const servicesPDP = servicePDPinfoForWarranty;

  if (isBuyTogetherSelected) {
    const sku = buyTogether?.buyTogetherVIP?.sku;
    const storeId = buyTogether?.buyTogetherVIP?.sellerId;
    const offerId = buyTogether?.buyTogetherVIP?.offerId;
    const extra = [{ sku, storeId, offerId, servicesPDP }];
    return getWarrantyUrl(productId, currentSku, sellerStoreId, productQty, extra);
  }
  const extraServicesPDP = servicesPDP ? [{ servicesPDP }] : [];

  return getWarrantyUrl(productId, currentSku, sellerStoreId, productQty, extraServicesPDP);
};

export const selectButtonFlow = ({
  isO2O,
  sellerStoreId,
  currentSku,
  warrantyUrl,
  experiment,
  modalWarrantyExperiment,
  hasServices,
  hasServiceSelected,
  isMobile,
  brand,
}) => {
  if (isO2O && !sellerStoreId) {
    return '#modal-select-store';
  }

  let url = warrantyUrl;
  const hasDiffs = !!currentSku?.diffs;
  const isUsed = currentSku?.offers?.result?.[0]?.condition === 'USED';

  const showWarrantyModal =
    hasServices &&
    !hasServiceSelected &&
    brand?.toLowerCase() === 'americanas' &&
    (!isMobile || modalWarrantyExperiment?.toUpperCase() === 'NEW');

  if (hasDiffs || isUsed) {
    url = experiment === 'NEW' ? '#modal-confirm-variation-new' : '#modal-confirm-variation';
  } else if (showWarrantyModal) {
    url = MODAL_WARRANTY_URL_REF;
  }

  return url;
};

export const getBuyButtonText = isPreSale => (isPreSale ? 'comprar na pré-venda' : 'comprar');

/**
 * Dispara as metricas e chama handleAddProduct para iniciar o fluxo de adicionar o(s) produto(s) no cart.
 * @return {void}
 */
export const sendMetrics = ({
  dispatchMetrics,
  servicePDPinfoForWarranty,
  setCookie,
  products,
  handleAddProduct,
}) => () => {
  if (!servicePDPinfoForWarranty) {
    dispatchMetrics('addToCart', {
      action: 'add',
      category: 'product',
      products,
    });
  }

  if (servicePDPinfoForWarranty) {
    dispatchMetrics('addToCart', {
      category: 'pdp-produtos-adjacentes',
      action: 'adicionar-produto',
      label: 'combo',
      products,
    });
  }

  if (products?.[0]?.hasProggresiveDiscount) {
    setCookie('catalogTestAB', 'showDiscountProgressive');
  }

  handleAddProduct();
};

export const getBrand = product => {
  const arrayWithObjectBrand = product?.attributes?.filter(({ name }) => name === 'Marca');
  const nameBrand = arrayWithObjectBrand?.[0]?.value;

  return nameBrand ? nameBrand : null;
};

export const getSellerType = (seller, config) => {
  const nameSeller = seller?.name?.toLowerCase();
  const nameBrand = config?.brandNameLower;

  return nameSeller === nameBrand ? 'B2C' : 'Marketplace';
};

export const addOfferFromComboVip = (currentOffers, buyTogetherVIP) => {
  const offers = currentOffers;
  if (buyTogetherVIP?.active) {
    offers.push({ offerId: buyTogetherVIP?.offerId, quantity: 1 });
  }

  return offers;
};
